import store from "../store"

const fetchDataPeticion = () => {
  return {
    type: "CHECK_DATA_PETICION",
  };
};

const fetchDataExitoso = (payload) => {
  return {
    type: "CHECK_DATA_EXITOSO",
    payload: payload,
  };
};

const fetchDataFallido = (payload) => {
  return {
    type: "CHECK_DATA_FALLIDO",
    payload: payload,
  };
};

// FETCH DATA DE LA BLOCKCHAIN

export const fetchData = (account) => {
  
  return async(dispatch)=>{


    dispatch(fetchDataPeticion());

      try {

        
        store.getState().blockchain.CStoryNftContract.options.address = '0xa307A4550f94e59e12A442BeFd4fc44C10046f77'

        let allStoryNfts = await store
        .getState()
        .blockchain.CStoryNftContract.methods.getAllNFT()
        .call();

        let allOwnerStoryNfts = await store
        .getState()
        .blockchain.CStoryNftContract.methods.getOwnerArmasNFT(account)
        .call();

       console.log(allOwnerStoryNfts) 
        

       dispatch(
        fetchDataExitoso({
          allStoryNfts,
          allOwnerStoryNfts,
          
        })
       ) 

      } catch (error) {

        dispatch(fetchDataFallido("Could not load data from contract."));

      }


  }
      
      
    }

